export const isValidNumberOrEmpty = (
  value: string | number | null
): boolean => {
  return (typeof value === "number" && !isNaN(value)) || value === "";
};
